export default __webpack_public_path__ + "static/media/LAS0820.34I-38284_-22494_0.1b3f8f4e.jpg";